<template>
  <div class="request-box-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('global.requestBox') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="requestBoxShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'RequestBoxHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            requestBoxShortcuts: [
                {
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.patientsManagement'),
                            shortcuts: [
                                { key: 'F10' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.patientsManagement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.processRequest'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.processRequest')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.cancelRequest'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: this.$t('component.shortcutsModal.delKey') }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.cancelRequest')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.printRequest'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'P' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.printRequest')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
